<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head.head-border
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb(:data="items")
        el-col.pt-5.text-right(:span="15")
          el-button(type="primary" size="mini" :loading="loading" @click="preserve()") 保存
          el-button(v-show="type==2" type="danger" size="mini" :loading="loading" @click="del") 删除
          el-button(type="primary" size="mini" @click="$router.go(-1)") 返回
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      el-row
        el-col(:span="20")
          div 基本信息
      el-form.mt-4(:model="form" ref="form" label-width="100px" size="mini" :rules="rules")
        el-row
          el-col(:span="12")
            el-form-item(label="名称:" prop="name")
              el-input.w-100(v-model="form.name")
            //- el-form-item(label="NC角色:" prop="nc_role_id")
            //-   el-select(v-model="form.nc_role_id" placeholder="请选择")
            //-     el-option(v-for="item in nc_list" :key="item.PK_RESPONSIBILITY" :label="item.name" :value="item.PK_RESPONSIBILITY")
            el-form-item(label="网页端菜单:" prop="rs")
              el-select(v-model="t" value-key="id" placeholder="请选择" @change="changeMenu($event,1)")
                el-option(v-for="item in pc_menu" :key="item.id" :label="item.title" :value="item.children")
              el-tree.mt-3(:data="d" show-checkbox node-key="id" ref="tree" @check-change="handleChange(1)" :default-checked-keys="keys" highlight-current :props="defaultProps")
                span.custom-tree-node(slot-scope="{ node, data }")
                  span.d-inline-block(style="width:100px") {{ data.title}}
                  span.ml-9(v-if="data && data.op_list")
                    el-checkbox-group.d-inline-block(v-model="data.check_list")
                      el-checkbox(v-for="(item,i) in data.op_list" :key="i" :label="item.code") {{item.name}}
            el-form-item(label="移动端菜单:")
              el-select(v-model="t1" value-key="id" placeholder="请选择" @change="changeMenu($event,2)")
                el-option(v-for="item in mobile_menu" :key="item.id" :label="item.title" :value="item.children")
              el-tree.mt-1(:data="d1" show-checkbox node-key="id" ref="tree1" @check-change="handleChange(2)" :default-checked-keys="keys1" highlight-current :props="defaultProps")
                span.custom-tree-node(slot-scope="{ node, data }")
                  span.d-inline-block(style="width:100px") {{ data.title}}
                  span.ml-9(v-if="data && data.op_list")
                    el-checkbox-group.d-inline-block(v-model="data.check_list")
                      el-checkbox(v-for="(item,i) in data.op_list" :key="i" :label="item.code") {{item.name}}
            el-form-item(label="状态")
              el-input.w-100(v-model="form.status")
            el-form-item(label="备注")
              el-input.w-100(v-model="form.remark")
</template>
<script>
export default {
  data() {
    return {
      h: "",
      form: {
        name: null,
        nc_role_id: null,
        prs: {},
        remark: null,
        rs: {},
        status: null,
      },
      loading: false,
      items: [
        {
          path: "/admin/role",
          meta: {
            title: "角色管理",
          },
        },
        {
          path: this.$route.path,
          meta: {
            title: "详情",
          },
        },
      ],
      rules: {
        name: [{ required: true, message: "请填写角色名称", trigger: "blur" }],
        nc_role_id: [
          { required: true, message: "请选择NC对应角色", trigger: "change" },
        ],
      },
      defaultProps: {
        children: "children",
        label: "title",
      },
      keys: [],
      keys1: [],
      pc_menu: [],
      mobile_menu: [],
      t: [],
      t1: [],
      d: [],
      d1: [],
      nc_list: [],
    };
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    type: {
      type: [Number, String],
      default: 1,
    },
  },
  methods: {
    changeMenu(e, type) {
      for (var i in e) {
        if (!e[i].check_list) this.$set(e[i], "check_list", []);
      }
      if (type == 1) {
        this.d = e;
      } else {
        this.d1 = e;
      }
    },
    handleChange(type) {
      if (type == 1) {
        this.form.rs = {};
        this.keys = this.$refs.tree.getCheckedKeys();
        let d = this.$refs.tree.getCheckedNodes();
        if (d.length) {
          for (var i in d) {
            this.form.rs[d[i].id] = d[i].check_list;
          }
        }
      } else {
        this.form.prs = {};
        this.keys1 = this.$refs.tree1.getCheckedKeys();
        let d1 = this.$refs.tree1.getCheckedNodes();
        if (d1.length) {
          for (var j in d1) {
            this.form.prs[d1[j].id] = d1[j].check_list;
          }
        }
      }
    },
    async preserve() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let res = null;
          let d = this.$refs.tree.getCheckedNodes();
          let d1 = this.$refs.tree1.getCheckedNodes();
          if (d.length) {
            for (var i in d) {
              this.form.rs[d[i].id] = d[i].check_list;
            }
          }
          if (d1.length) {
            for (var j in d1) {
              this.form.prs[d1[j].id] = d1[j].check_list;
            }
          }
          if (this.type == 1) {
            res = await this.$api.role.add(this.form);
          } else {
            res = await this.$api.role.edit(this.form);
          }
          this.loading = false;
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.$router.go(-1);
          }
        }
      });
    },
    del() {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          this.loading = true;
          let res = await this.$api.role.del(this.id);
          this.loading = false;
          if (res) {
            this.$router.go(-1);
            this.$notify({
              message: "操作成功",
              type: "success",
            });
          }
        })
        .catch(() => {});
    },
    async getNcList() {
      let res = await this.$api.role.getNcList(this.list);
      if (res) {
        this.nc_list = res.data;
      }
    },
    async getById() {
      let res = await this.$api.role.getById(this.id);
      await this.$utils.sleep(200);
      if (res) {
        this.keys = Object.keys(res.data.rs);
        for (var i in this.pc_menu) {
          for (var j in this.pc_menu[i].children) {
            this.$set(this.pc_menu[i].children[j], "check_list", []);
            for (var n in res.data.rs) {
              if (
                this.pc_menu[i].children[j].id == n &&
                res.data.rs[n].length > 0
              ) {
                this.pc_menu[i].children[j]["check_list"] =
                  typeof res.data.rs[n] === "string"
                    ? res.data.rs[n].split(",")
                    : res.data.rs[n];
              }
            }
            if (this.pc_menu[i].children[j].id == this.keys[0]) {
              this.t = this.pc_menu[i].children;
            }
          }
        }
        this.keys1 = Object.keys(res.data.prs);
        for (var e in this.mobile_menu) {
          for (var f in this.mobile_menu[e].children) {
            this.$set(this.mobile_menu[e].children[f], "check_list", []);
            for (var g in res.data.prs) {
              if (
                this.mobile_menu[e].children[f].id == g &&
                res.data.prs[g].length > 0
              ) {
                this.mobile_menu[e].children[f]["check_list"] =
                  typeof res.data.prs[g] === "string"
                    ? res.data.prs[g].split(",")
                    : res.data.prs[g];
              }
            }
            if (this.mobile_menu[e].children[f].id == this.keys1[0]) {
              this.t1 = this.mobile_menu[e].children;
            }
          }
        }
        this.d = this.t;
        this.d1 = this.t1;
        this.form = res.data;
      }
    },
    async getPcMenu() {
      this.loading = true;
      let res = await this.$api.menu.getMenu();
      this.loading = false;
      if (res) {
        this.pc_menu = res.data;
      }
    },
    async getMobileMenu() {
      this.loading = true;
      let res = await this.$api.menu_phone.getMenu();
      this.loading = false;
      if (res) {
        this.mobile_menu = res.data;
      }
    },
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created() {
    this.getPcMenu();
    this.getMobileMenu();
    this.getNcList();
    if (this.type == 1) {
      this.items[1].meta.title = "新增";
    } else {
      this.getById();
      this.items[1].meta.title = "修改";
    }
  },
};
</script>